import { grey } from "@mui/material/colors";

const styles = {
  cardBgActive: {
    borderRadius: 4,
    py: 2,
  },
  container: {
    mb: 3,
    px: 3,
    pb: 3,
    borderBottom: `1px solid ${grey[200]}`,
  },
  chip: {
    px: 2,
    backgroundColor: "white",
    py: 1,
    borderRadius: 10,
    border: `1px solid ${grey[200]}`,
    width: "max-content",
    display: "flex",
    alignItems: "center",
    mb: 2,
  },
  circle: {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    width: 20,
    height: 20,
    borderRadius: "50%",
    backgroundColor: "primary.main",
    color: "white",
    fontSize: 12,
    mr: 1,
  },
};

export default styles;
